import React, { useState, useEffect, useRef } from "react";
import Fade from "@material-ui/core/Fade";
import { Link } from "react-scroll";

const ScrollToTop = () => {
  const [inView, setInView] = useState(false);
  const backToTopRef = useRef(null);

  useEffect(() => {
    const sticky = document.getElementById("back-to-top");
    const footer = document.getElementById("footer");
    const stickyHeight = sticky?.clientHeight || 0;
    const remDivider = parseInt(
      window.getComputedStyle(document.body).fontSize
    );
    const stickyBottom = 1.25;
    const fromTop = -1;
    const fromHTML = document.getElementById("main")?.firstChild?.nextSibling;

    const handleScroll = () => {
      if (isInViewport(fromHTML, fromTop)) {
        fadeIn();
        checkY(footer, sticky, stickyBottom, stickyHeight, remDivider);
      } else {
        fadeOut();
        checkY(footer, sticky, stickyBottom, stickyHeight, remDivider);
      }
    };

    if (window.location.pathname === "/clients") {
      sticky.style.display = "none";
    }

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const fadeIn = () => {
    setInView(true);
  };

  const fadeOut = () => {
    setInView(false);
  };

  const isInViewport = (elem, fromTop) => {
    if (!elem) return false;
    const bounding = elem.getBoundingClientRect();
    return window.screenTop - bounding.top > fromTop;
  };

  const checkY = (footer, sticky, stickyBottom, stickyHeight, remDivider) => {
    if (!footer || !sticky) return;

    if (
      window.scrollY + window.innerHeight <
      document.body.scrollHeight - footer.clientHeight
    ) {
      sticky.style.bottom = `${stickyBottom}rem`;
      sticky.classList.remove("sticky-fixed-footer");
    }

    if (
      window.scrollY + window.innerHeight >
      document.body.scrollHeight - footer.clientHeight
    ) {
      sticky.style.bottom = `${stickyHeight / remDivider + stickyBottom}rem`;
      sticky.classList.add("sticky-fixed-footer");
    }
  };

  const page = document.body.classList.contains("header-fixed-true")
    ? "main"
    : "header";

  return (
    <Fade in={inView} timeout={600}>
      <div
        id="back-to-top"
        style={{ display: "block", marginBottom: "100px" }}
        ref={backToTopRef}
      >
        <Link
          to={page}
          spy={true}
          smooth={true}
          duration={0}
          className="scroll-to-id transform-scale-h"
        >
          <i className="fas fa-long-arrow-alt-up"></i>
        </Link>
      </div>
    </Fade>
  );
};

export default ScrollToTop;
